import { DatasetPlaceholder } from "~/pages/manifold-nextgen/components/datasets/DatasetPlaceholder";

export const DatasetFiles = () => <DatasetPlaceholder label="Files" />;
